var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("div", { staticClass: "d-print-none float-lg-right mb-3" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary login-page-button",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Btn_ClosePrivacyPolicy")) + "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary login-page-button",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.print()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Btn_PrintPrivacyPolicy")) + "\n    "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("PrivacyPolicy")))]),
        _vm._v(" "),
        _vm.showFinnish
          ? _c("div", [
              _c("p", [
                _vm._v("SELOSTE HENKILÖREKISTERIN KÄSITTELYTOIMISTA 1.7.2019")
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("h2", [_vm._v("1. Rekisterinpitäjä")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Sosiaali- ja terveysjärjestöjen avustuskeskus (STEA) / sosiaali- ja terveysministeriö (STM)"
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Meritullinkatu 8, 00170 Helsinki")]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("h2", [
                _vm._v("2. Yhteyshenkilö rekisteriä koskevissa asioissa")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Timo Mulari, erityisasiantuntija, STEA, Meritullinkatu 8, 00170 Helsinki"
                )
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("h2", [_vm._v("3. Tietosuojavastaava")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lassi Kauttonen, Sosiaali- ja terveysministeriö, Meritullinkatu 8, PL 33, 00023 Valtioneuvosto"
                )
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("h2", [_vm._v("4. Henkilötietojen käsittelyn tarkoitus")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Henkilötietoja käsittelevät sosiaali- ja terveysministeriön Sosiaali- ja terveysjärjestöjen avustuskeskuksessa (STEA) työskentelevät virkamiehet ainoastaan virkatehtäviensä hoitamiseen liittyvässä tarkoituksessa."
                )
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("h2", [_vm._v("5. Rekisterin tietosisältö")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEAn rekisteri sisältää ensisijaisesti yhteisöihin ja säätiöihin liittyviä tietoja."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Näiden tietojen yhteydessä käsitellään seuraavia henkilötietoja:"
                )
              ]),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEA tallentaa vain STEAn toiminnan ja tietojen käyttötarkoitusten kannalta tarpeellisia tietoja, joiden käsittelylle on lailliset edellytykset. STEAlle toimitetut asiakirjat tietoineen säilytetään pysyvästi. Tarpeettomiksi muuttuneet tai vanhentuneet tiedot hävitetään tietoturvallisesti sen jälkeen, kun tietojen käsittelylle ei enää ole perustetta."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("6. Saatujen henkilötietojen lähteet")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Tietoja saadaan ensisijaisesti asiakkaalta itseltään tai asiakkaan edustamalta yhteisöltä tai säätiöltä palvelujen käytön ja asiakaspalvelun yhteydessä. Palvelutietoa kerätään asiakkaan käyttäessä palveluja."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Asiakkaaseen liittyviä tietoja voidaan hankkia ja päivittää lainsäädännön mahdollistamissa tapauksissa asiakkaalle informoituihin käyttötarkoituksiin myös ulkoisista tietolähteistä, esim. verohallinnolta, patentti- ja rekisterihallitukselta sekä yritys- ja luottotietoyhtiöiltä."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("7. Tietojen säännönmukaiset luovutukset")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Siltä osin kuin kyse ei ole julkisuuslain alaisesta tiedosta asiakkaan henkilötietoja ei luovuteta STEAn/STM:n tai STEAn/STM:n lukuun toimivien palvelua ylläpitävien ja kehittävien tai palvelukokonaisuuden tuotantoon osallistuvien kolmansien tahojen ulkopuolelle. Viranomaisille tietoja luovutetaan laissa säädetyissä tapauksissa sekä väärinkäytösten ehkäisemiseksi ja selvittämiseksi."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Julkisuuslain perusteella tämän rekisterin henkilötiedot ovat pääsääntöisesti julkisia, ellei laissa erikseen toisin säädetä."
                )
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(
                  "8. Säännönmukaiset tietojen luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolella"
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Tietoja ei luovuteta eteenpäin.")]),
              _vm._v(" "),
              _c("h2", [_vm._v("9. Rekisterin suojauksen periaatteet")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEAn rekisterin tietoturvallisuus sekä henkilötietojen luottamuksellisuus, eheys ja käytettävyys varmistetaan tarkoituksenmukaisin teknisin ja hallinnollisin toimenpitein. Henkilötiedot suojataan asiattomalta pääsyltä ja laittomasti tai vahingossa tapahtuvalta tietojenkäsittelyltä. Henkilötietoja käsittelevät vain STEAn henkilöt, jotka tarvitsevat näitä tietoja virkatehtävien hoitamiseksi sekä STEAn toimeksiannosta palveluja ylläpitävät tai kehittävät kolmannet osapuolet, joiden tehtäviin henkilötietojen käsittely kuuluu."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEAn tarjoama verkkopalvelu on suojattu SSL-sertifikaatilla, mistä asiakas tunnistaa kyseisen palvelun oikeellisuuden. Rekisteriin liittyvät tietojärjestelmät tunnistautuvat molempiin suuntiin SSL-palvelinsertifikaattien avulla."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("10. Rekisteröidyn oikeudet")]),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Oikeuksien käyttämiseksi rekisteröidyn tulee tehdä kirjallinen pyyntö sosiaali- ja terveysministeriön kirjaamoon. Pyytäjän tulee kyetä todistamaan henkilöllisyytensä. Pyynnössä on yksilöitävä mitä oikeutta rekisteröity käyttää, sekä siihen liittyvä yksilöivä informaatio riittävällä tarkkuudella, jotta pyyntö voidaan toteuttaa. Sosiaali- ja terveysministeriö käsittelee tietopyynnön ja vastaa siihen oman ohjeistuksensa mukaisesti."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Rekisteröity voi tehdä valituksen tietosuojavaltuutetun toimistolle, joka valvoo henkilötietojen käsittelyn lainmukaisuutta ja ihmisten tietosuojaoikeuksien toteutumista Suomessa. Ohjeistus valituksen tekemiseen löytyy tietosuojavaltuutetun toimiston verkkosivuilta."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("11. Evästeiden käyttö")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          STEA käyttää verkkopalvelussaan istuntokohtaisia evästeitä (cookies) palvelujen toteuttamiseksi ja helpottamaan palvelun käyttöä. Evästeitä ja niiden avulla kerättäviä tietoja käytetään myös verkkopalvelun käytettävyyden ja käytön analysoimiseksi, seurantaan ja palvelun kehittämiseksi. Asiakas voi antaa suostumuksensa evästeiden käytölle tai kieltää sen selaimensa asetuksista. Evästeet ovat tarpeellisia joidenkin palvelujen toimivuudelle, joten STEA ei takaa kaikkien palvelujen toimivuutta, jos evästetoiminnallisuus ei ole käytössä.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [_c("cookie-consent-info")], 1),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-between" }, [
                _c("div", { staticClass: "col align-self-center" }, [
                  _c("strong", [
                    _vm._v(
                      "\n              Olet hyväksynyt " +
                        _vm._s(
                          _vm.consentedToAll
                            ? "kaikki evästeet"
                            : "välttämättömät evästeet"
                        ) +
                        ".\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col right" }, [
                  _vm.consentedToAll == true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-necessary",
                          attrs: { type: "button" },
                          on: { click: _vm.consentNecessary }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("CookieConsent.Necessary")) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.consentedToAll == false
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-all",
                          attrs: { type: "button" },
                          on: { click: _vm.consentAll }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("CookieConsent.All")) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showSwedish
          ? _c("div", [
              _c("p", [
                _vm._v(
                  "BESKRIVNING AV BEHANDLINGEN AV UPPGIFTERNA I PERSONREGISTRET 1.7.2019"
                )
              ]),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c("h2", [_vm._v("1. Personuppgiftsansvarig")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Social- och hälsoorganisationers understödscentral (STEA)/Social- och hälsovårdsministeriet (SHM)"
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Sjötullsgatan 8, 00170 Helsingfors")]),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _c("h2", [_vm._v("2. Kontaktperson i registerärenden")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Timo Mulari, specialsakkunnig, STEA, Sjötullsgatan 8, 00170 Helsingfors"
                )
              ]),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _c("h2", [_vm._v("3. Dataskyddsombud")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lassi Kauttonen, Social- och hälsovårdsministeriet, Sjötullsgatan 8, PB 33, 00023 Statsrådet"
                )
              ]),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              _c("h2", [
                _vm._v("4. Ändamål för behandlingen av personuppgifter")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Personuppgifter behandlas av tjänstemän vid Social- och hälsoorganisationernas understödscentral (STEA) i anslutning till Social- och hälsovårdsministeriet endast i ändamål som anknyter till skötseln av deras tjänsteuppgifter."
                )
              ]),
              _vm._v(" "),
              _vm._m(13),
              _vm._v(" "),
              _c("h2", [_vm._v("5. Registrets datainnehåll")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEA:s register innehåller i första hand uppgifter om organisationer och stiftelser."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "I samband med dessa behandlas följande personuppgifter:"
                )
              ]),
              _vm._v(" "),
              _vm._m(14),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEA lagrar endast uppgifter som är nödvändiga med tanke på STEA:s verksamhet och uppgifternas användningsändamål och för behandlingen av vilka det finns lagliga förutsättningar. Dokument som lämnas in till STEA förvaras permanent. Uppgifter som blivit onödiga eller föråldrats förstörs datasäkert efter att det inte längre finns någon grund för behandlingen av uppgifterna."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("6. Källor för personuppgifterna")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Information fås i första hand från kunden själv eller av den organisation kunden representerar eller av stiftelsen i samband med användningen av tjänsterna och kundservicen. Serviceinformation samlas in då kunden använder tjänsterna."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Uppgifter om kunden kan inhämtas och uppdateras även från andra externa informationskällor, såsom skatteförvaltningen, patent- och registerstyrelsen samt företags- och kreditupplysningsbolag, i fall som möjliggörs av lagstiftningen och för användningsändamål om vilka kunden informerats."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("7. Regelmässigt utlämnande av uppgifter")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Till de delar som det gäller information som omfattas av offentlighetslagen lämnas kundens personuppgifter inte ut av STEA/SHM eller tredje parter som verkar för deras räkning och underhåller och utvecklar tjänsten, samt deltar i produktionen av servicehelheten. Uppgifter lämnas ut till myndigheter så som föreskrivs i lag samt för att förebygga och utreda missbruk."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Personuppgifterna i detta register är med stöd av offentlighetslagen i regel offentliga, såvida inte annat föreskrivs i lag."
                )
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(
                  "8. Regelmässigt utlämnande av uppgifter och överföring av uppgifter till länder utanför EU eller EES"
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Uppgifterna lämnas inte ut.")]),
              _vm._v(" "),
              _c("h2", [_vm._v("9. Principerna för skyddet av registret")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Datasäkerheten för STEA:s register samt konfidentialiteten, helheten och användbarheten för personuppgifterna säkras genom ändamålsenliga tekniska och administrativa åtgärder. Personuppgifterna skyddas mot obehörigt tillträde och mot databehandling som sker olagligt eller av misstag. Personuppgifter behandlas enbart av den personal vid STEA som behöver uppgifterna för att sköta sina tjänsteuppgifter samt av de tredje parter som på uppdrag av STEA utvecklar tjänsterna och i vilkas arbetsuppgifter behandlingen av personuppgifterna ingår."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Den e-tjänst som tillhandahålls av STEA är skyddad med SSL-certifikat, genom vilket användaren identifierar att den aktuella tjänsten är riktig. De datasystem som hör till registret identifierar sig i båda riktningarna med hjälp av SSL-servercertifikaten."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("10. De registrerades rättigheter")]),
              _vm._v(" "),
              _vm._m(17),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "För att använda sina rättigheter ska den registrerade framföra en skriftlig begäran till social- och hälsovårdsministeriets registratorskontor. Den som framför begäran ska kunna bestyrka sin identitet. I begäran ska specificeras vilken rätt den registrerade använder samt anknytande identifierande information med tillräcklig noggrannhet för att begäran ska kunna godtas. Social- och hälsovårdsministeriet behandlar informationsbegäran och besvarar den enligt sina instruktioner."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "De registrerade kan anföra besvär hos dataombudsmannens byrå som övervakar lagenligheten i behandlingen av personuppgifter och att människors dataskyddsrättigheter tillgodoses i Finland. Besvärsanvisningen finns på webbplatsen för dataombudsmannens byrå."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("11. Användning av kakor")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEA använder i kakor (cookies) i sin e-tjänst för att genomföra tjänsterna och underlätta användningen av dem. Kakor och information som samlas in med hjälp av dem används även för att analysera webbtjänstens användbarhet och användning samt för att uppfölja och utveckla tjänsten. Kunden kan aktivera eller spärra kakorna i inställningarna på sin webbläsare. Kakorna är nödvändiga för att vissa tjänster ska kunna fungera, så STEA garanterar inte att alla tjänster fungerar om funktionen inte är aktiverad."
                )
              ]),
              _vm._v(" "),
              _c("p", [_c("cookie-consent-info")], 1),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-between" }, [
                _c("div", { staticClass: "col align-self-center" }, [
                  _c("strong", [
                    _vm._v(
                      "\n              Du har godkänt " +
                        _vm._s(
                          _vm.consentedToAll ? "alla kakor" : "nödvändiga kakor"
                        ) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col right" }, [
                  _vm.consentedToAll == true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-necessary",
                          attrs: { type: "button" },
                          on: { click: _vm.consentNecessary }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("CookieConsent.Necessary")) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.consentedToAll == false
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-all",
                          attrs: { type: "button" },
                          on: { click: _vm.consentAll }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("CookieConsent.All")) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          STEA verkkoasiointi ja avustustenhallintajärjestelmä"
      ),
      _c("br"),
      _vm._v(
        "\n          Yleinen EU tietosuoja-asetus, artiklat 12-14, 30\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Sähköposti: stea(at)gov.fi"),
      _c("br"),
      _vm._v("\n          Puhelin: vaihde 0295 16001\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Sähköposti: timo.mulari(at)gov.fi"),
      _c("br"),
      _vm._v("\n          Puh. vaihde 0295 16001\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Sähköposti: stmtietosuojavastaava(at)gov.fi"),
      _c("br"),
      _vm._v("\n          Puh. 0295 16001 (vaihde)\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          STEAssa käsiteltävien henkilötietojen käyttötarkoituksia ovat:\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Avustustoiminnan toteuttaminen ja valtionavustuksista annetussa laissa (2001/688) määritellyt tehtävät ja toimenpiteet, kuten avustushakemusten käsittely, avustusehdotuksen valmistelu, avustusten maksaminen, avustusten käytön valvonta ja avustusten tulosten ja vaikutusten arviointi."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Asiakkaan palveleminen ja asiakassuhteen operatiivinen hoito, hallinta ja kehittäminen."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Asiakastietojen sekä asiakas- ja kontaktihistorian hallinta. Tuki- ja neuvontapalvelujen järjestäminen asiakkaalle sekä palvelutoimenpiteiden hallinta."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "STEAn toiminnan ja palvelujen analysointi, raportointi ja kehittäminen."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Avustustoiminnan laadun ja turvallisuuden varmistaminen.")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Viestinnän toteuttaminen ja seuranta. Palautteen käsittely. Viestintähistorian hallinta."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Asiakkaan tunnistaminen. Asiakkaiden yksilöinti (identifiointi), todentaminen (autentikointi) ja valtuuttaminen (auktorisointi) STEAn palveluissa. Käyttöoikeuksien ja pääsyn hallinta."
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Palvelujen tietoturvallisuus.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Asiakkaiden ja STEAn oikeusturvan varmistaminen sekä lakiin perustuvien ja viranomaismääräysten mukaisten velvoitteiden hoitaminen. Väärinkäytösten ja ongelmatilanteiden ehkäisy ja selvittäminen."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Henkilön perustiedot:\n          "),
      _c("ul", [
        _c("li", [_vm._v("Henkilötunnus")]),
        _vm._v(" "),
        _c("li", [_vm._v("Nimi")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Yhteystiedot: osoite, puhelinnumero, sähköpostiosoite")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Organisaatio, johon henkilö kuuluu")]),
        _vm._v(" "),
        _c("li", [_vm._v("Titteli/ rooli ja mahdollinen nimenkirjoitusoikeus")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          Avustustoiminnan toteuttamisessa tarvittavat henkilötiedot:\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Asiakirjoista ilmenevät sekä muut palvelun toteuttamisen yhteydessä tallennettavat avustushakemusten käsittelyssä, avustusehdotuksen valmistelussa, avustusten maksamisessa, avustusten käytön valvonnassa ja avustusten vaikutusten arvioinnissa sekä päätösten tekemisessä tarpeelliset henkilötiedot"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Tiedot ulkoisista tietolähteistä (tarkemmin kohdassa 6)")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Asiakkaan palvelujen käyttö")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Asiakasviestintä ja -palaute sekä kontaktihistoria")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Järjestelmien lokitiedot sekä tietojen käsittelyyn liittyvät tiedot"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          Verkkopalvelujen käyttöön liittyvät tiedot:\n          "
      ),
      _c("ul", [
        _c("li", [_vm._v("Käyttäjätunnus ja salasana")]),
        _vm._v(" "),
        _c("li", [_vm._v("Käyttöoikeudet")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("IP-osoite jokaisen palveluun kirjautumisen yhteydessä")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          Tietosuoja-asetuksen mukaisesti rekisteröidyllä on lainsäädännössä säädettyjä poikkeuksia lukuun ottamatta:\n\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v("oikeus saada informaatiota henkilötietojen käsittelystä")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("oikeus saada pääsy henkilötietoihin")]),
        _vm._v(" "),
        _c("li", [_vm._v("oikeus tietojen oikaisemiseen")]),
        _vm._v(" "),
        _c("li", [_vm._v("oikeus käsittelyn rajoittamiseen")]),
        _vm._v(" "),
        _c("li", [_vm._v("oikeus vastustaa tietojen käsittelyä")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          STEA:s e-tjänst och system för hantering av understöd"
      ),
      _c("br"),
      _vm._v(
        "\n          EU:s allmänna dataskyddsförordning, artiklarna 12–14, 30\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          E-post: stea(at)gov.fi"),
      _c("br"),
      _vm._v("\n          Tfn växel 0295 16001\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          E-post: timo.mulari(at)gov.fi"),
      _c("br"),
      _vm._v("\n          Tfn växel 0295 16001\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          E-post: stmtietosuojavastaava(at)gov.fi"),
      _c("br"),
      _vm._v("\n          Tfn 0295 16001 (växel)\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          Användningsändamålen för personuppgifterna som behandlas vid STEA är följande:\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Att genomföra understödsverksamheten och utföra de uppgifter och åtgärder som fastställts i lagen om penningautomatunderstöd (2001/688), såsom behandling av ansökningar om understöd, beredning av understödsbeslut, utbetalning av understöd, övervakning av användningen av understöd och uppföljning av understödets inverkningar."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att betjäna kunden och att operativt sköta, hantera och utveckla kundrelationen."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att hantera kunduppgifter samt kund- och kontakthistoriken. Att ordna stöd- och rådgivningstjänster för kunden samt att hantera serviceåtgärder."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att analysera, rapportera om och utveckla STEA:s verksamhet och tjänster."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att säkerställa understödsverksamhetens kvalitet och säkerhet."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att genomföra och uppfölja kommunikationen. Att behandla respons. Att hantera informationshistoriken."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att identifiera kunderna. Att identifiera, autentisera och auktorisera kunder i STEA:s tjänst. Att hantera användarrättigheter och tillträde."
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Att se till tjänsternas datasäkerhet.")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Att säkerställa rättsskyddet för kunderna och STEA samt att sköta de åligganden som grundar sig på lag och som stämmer överens med myndighetsbestämmelserna. Att förhindra och utreda missbruk och problemsituationer."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n          Basuppgifter om personen:\n          "),
      _c("ul", [
        _c("li", [_vm._v("Personbeteckning")]),
        _vm._v(" "),
        _c("li", [_vm._v("Namn")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Kontaktuppgifter: adress, telefonnummer, e-postadress")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Organisation som personen tillhör")]),
        _vm._v(" "),
        _c("li", [_vm._v("Titel/roll och eventuell rätt att teckna firma")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          Personuppgifter som behövs för genomförandet av understödsverksamheten:\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v(
            "De personuppgifter som framkommer av dokument och andra nödvändiga personuppgifter som sparas i samband med behandlingen av ansökan om understöd, beredningen av understödsbeslut, utbetalningen av understöd, övervakningen av hur understödet används och vid uppföljningen av understödets inverkan samt vid beslutsfattandet."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Uppgifter om externa informationskällor (specificeras under punkt 6)"
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Hur kunden använder tjänsterna")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Kommunikation med kunderna och kundrespons samt kontakthistorik"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Logguppgifter för systemen samt uppgifter som hänför sig till behandlingen av uppgifterna"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          Uppgifter som hänför sig till e-tjänsten:\n          "
      ),
      _c("ul", [
        _c("li", [_vm._v("Användarnamn och lösenord")]),
        _vm._v(" "),
        _c("li", [_vm._v("Användarrättigheter")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("IP-adress i samband med varje inloggning i tjänsten")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n          I enlighet med dataskyddsförordningen har de registrerade, med de undantag som föreskrivs i lagen, rätt:\n\n          "
      ),
      _c("ul", [
        _c("li", [
          _vm._v("att få information om behandlingen av personuppgifterna")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("att få tillgång till personuppgifterna")]),
        _vm._v(" "),
        _c("li", [_vm._v("till rättelse av uppgifter")]),
        _vm._v(" "),
        _c("li", [_vm._v("att begränsa behandlingen")]),
        _vm._v(" "),
        _c("li", [_vm._v("att motsätta sig behandlingen av uppgifterna")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }